import { request, spUrl } from "utils";

import { HAPLO_REPOSITORY_API } from "globals/constants";

const fetchData = id => {
	return request(spUrl(`${HAPLO_REPOSITORY_API}/${id}`))
		.then(result => result.allItems.map(repo => {
			return {
				...repo
			}
		}
	));
};

const Helper = {
	apiKey: "repositoryId",
	fetchData
}

export default Helper;